import { render } from "./HealthDark.vue?vue&type=template&id=1f7cc56c"
import script from "./HealthDark.vue?vue&type=script&lang=js"
export * from "./HealthDark.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__